import React from 'react'
import ProjectInfo from '../ProjectInfo'

import trello from "../../../../Assets/images/projects/trellodetailed.png"


export default function Trello() {
    return (
        <ProjectInfo pic={trello}
            title="Kanban Project Manager"
            maincolor="#5553dd"
            accentcolor="#de316f"
            link="https://jrwolf-todoapp.netlify.app/"
            githublink="https://github.com/Jrwolf99/TrelloClone"
        >

            <p>Looking extraordinarily similar to Trello, this kanban project manager
                is my version of the famous project manager tool. In using Trello
                as my main project manager for a variety of projects, I was inspired to recreate it.
            </p>
            <br />
            <p>This clone was developed using React, and all data is saved in Google's Firebase.
                This application also secures user authentication through Firebase.</p>
            <br />


        </ProjectInfo>
    )
}
